import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';
import { date, email, fullContact, postcode } from 'Utils/validations';

export const AddressFormSchema = Yup.object().shape(
    reverseShape({
        type: Yup.mixed().oneOf(['HOME', 'OFFICE', 'WAREHOUSE']).required(),
        street1: Yup.string().max(100).required(),
        street2: Yup.string().max(100).optional(),
        city: Yup.string().max(50).required(),
        state: Yup.string().max(50).required(),
        cityCode: Yup.string().max(50).optional(),
        stateCode: Yup.string().max(50).optional(),
        postcode: Yup.string()
            .when('country', { is: 'MY', then: postcode.required() }),
        country: Yup.string().matches(/^[a-zA-Z]{2}$/i).required()
    })
)
export const UpdateProfileFormSchema = Yup.object().shape(
    reverseShape({
        fullName: Yup.string().min(3).max(100).required(),
        gender: Yup.mixed().oneOf(['MALE', 'FEMALE']).optional(),
        identificationType: Yup.mixed().oneOf(['PASSPORT', 'NRIC', 'UN']).required(),
        identificationNumber: Yup.string()
            .when('identificationType',
                { is: 'PASSPORT', then: Yup.string().matches(/^[a-zA-Z0-9]+$/).min(5) })
            .when('identificationType',
                { is: 'NRIC', then: Yup.string().matches(/^((([[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01]))([0-9]{2})([0-9]{4}){1})$/i) })
            .required(),
        primaryPhone: Yup.object().required().concat(fullContact),
        primaryEmail: email.required(),
        primaryAddress: Yup.object().shape({
            type: Yup.mixed().oneOf(['HOME', 'OFFICE', 'WAREHOUSE']).required(),
            street1: Yup.string().max(100).required(),
            street2: Yup.string().max(100),
            city: Yup.string().max(50).required(),
            state: Yup.string().max(50).required(),
            cityCode: Yup.string().max(50).optional(),
            stateCode: Yup.string().max(50).optional(),
            postcode: Yup.string()
                .when('country', { is: 'MY', then: postcode.required() }),
            country: Yup.string().matches(/^[a-zA-Z]{2}$/i).required()
        }).required(),
        // dob: Yup.string().matches(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/).optional(),
        dob: Yup.mixed().optional().concat(date),
    })
)
